module.exports = __webpack_public_path__ + "static/img/squire-patton-boggs.91b2cee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/home-page-logos/squire-patton-boggs.png
// module id = CP5D
// module chunks = 0